
<main  #scroll>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter
                    (keyup)="applySearch($event)" placeholder="ગામ શોધો.." />
                 <i class="ti ti-search"></i> 
            </form>
            <!-- <i class="ti ti-filter"></i> -->
        </div>
    </div>
    <hr>
    <div class="add-district">
        <h5 class="mb-3">ગામ</h5>
        <div class="loginWraper">
            <form [formGroup]="VillageForm">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="district-form-group">
                                <div class="input-grp">
                                    <input type="text" class="form-control" placeholder="ગામ નામ"
                                        formControlName="village_name" required="" />
                                    <div *ngIf="submitted && f.village_name.errors" class="error-message">
                                        <small *ngIf="f.village_name.errors?.required" class="text-danger">ગામ નું નામ
                                            જરૂરી
                                            છે.</small>
                                    </div>
                                </div>
                                <button type="submit" *ngIf="buttonclick == false" (click)="villageAdd()"><i
                                        class="ti ti-plus"></i></button>
                                <button type="submit" *ngIf="buttonclick == true" (click)="villageEdit()"><i
                                        class="ti ti-pencil"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>


    <div class="city-list district_list table-responsive">
        <table class="member-list-item">
            <thead>
                <tr>
                    <th class="table-header">ગામડાઓ</th>
                    <th class="table-header">સભ્યોની સંખ્યા</th>
                    <th class="table-header">ફેરફાર</th>
                    <th class="table-header">સક્રિય / નિષ્ક્રિય</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of villageData">
                    <td class="td-spacing">
                        <h5>{{data.village_name}}</h5>
                    </td>
                    <td class="td-spacing">
                        <h5 class="text-primary">{{data.persons  == 0 ? '-' : data.persons}} </h5>
                    </td>
                    <td class="td-spacing">
                        <button (click)="EditVillage(data)" class="btn-common edit-btn">
                            <i class="ti ti-pencil"></i>
                        </button>
                    </td>
                    <td class="td-spacing">
                        <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin" 
                            [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)">
                        </mat-slide-toggle>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</main>